/**
 * Version Comparison Service Layer
 *
 * Pure API service functions for fetching document content.
 * No business logic, no state management - just API calls.
 */

import axios from 'axios'

import { GetDocumentContentParams } from './types'

export type SecondParameter<T extends (...args: never) => unknown> =
  Parameters<T>[1]

/**
 * Get file content from a signed blob URL and decodes it as UTF-8
 * @param signedUrl - The signed blob URL from documentVersion.signed_blob_url
 * @param signal - Optional AbortSignal for request cancellation
 * @returns Promise that resolves to the decoded HTML string
 */
export const getFileContentByBlobURL = async (
  params: GetDocumentContentParams,
  signal?: AbortSignal
): Promise<string> => {
  const response = await axios.get<ArrayBuffer>(params.signedUrl ?? '', {
    responseType: 'arraybuffer',
    signal,
    headers: {},
  })

  // Decode the ArrayBuffer to string using UTF-8
  const decoder = new TextDecoder('utf-8')
  return decoder.decode(response.data)
}
